localStorage.clear();
localStorage.setItem('selected-package', "8");


// get current year
var date = new Date();
var year = date.getFullYear();
$("#year").text(year);

$(".package-box__options__box").on("click", function() {
  var savings = 0;
  var total = 0;
  var shipping = 0;
  var id = $(this).data("id");

  $(".package-box__options__box").each(function() {
    $(this).removeClass("selected");
  });
  $(this).addClass("selected");

  switch(id) {
    case 1:
      savings = 30.00;
      total = 67.00;
      shipping = 6.95;
      break;
    case 4:
      savings = 63.50;
      total = 33.50;
      shipping = 0;
      break;
    case 8:
      savings = 72.05;
      total = 24.95;
      shipping = 0;
      break;
  }

  $("#savings").html(savings.toFixed(2));
  $("#total").html(total.toFixed(2));

  if (shipping !== 0) {
    $("#shipping").html("+ " + shipping.toFixed(2));
  } else {
    $("#shipping").html("Free");
  }

  localStorage.setItem('selected-package', id);
});

$('#ctaLink').click(function (e) { 
  e.preventDefault();
  $('#form').submit();
});


// PROOF WIDGET
$(document).ready(function () {
  if ($(window).width() >= 767) {
    var getProof = function () {
      $.ajax({
        url: "https://clients.thirdelementmarketing.com/api/lastcustomer.asp",
        success: function (data) {
          var parsedData = JSON.parse(data);
          var randomNumber = Math.floor(Math.random() * parsedData.length);
  
          $("#proof-name").text(parsedData[randomNumber].firstname);
          $("#proof-location").text(parsedData[randomNumber].city + ", " + parsedData[randomNumber].state);
  
  
          if (parsedData[randomNumber].hago === "0") {
            $("#proof-hago").text("less than an hour ago");
          } else {
            if (parsedData[randomNumber].hago === "1") {
              $("#proof-hago").text("1 hour ago");
            } else {
              $("#proof-hago").text(parsedData[randomNumber].hago + " hours ago");
            }
          }
  
        }
      });
    }
  
    getProof();
  
    $(".proof-widget").hover(function() {
      $("#close-proof-widget").fadeToggle();
    })
  
  
    $(".proof-widget").addClass("proof-widget--shown");
  
    var proofInterval = setInterval(function () {
  
      $(".proof-widget").toggleClass("proof-widget--shown");
  
    }, 6000);
  
    var proofRandom = setInterval(function () {
      getProof();
    }, 12000);
  
    $("#close-proof-widget").on("click", function() {
        console.log("clicked");
        $(".proof-widget").removeClass("proof-widget--shown");
        clearInterval(proofInterval);
        clearInterval(proofRandom);
      })
  }
});
// END PROOF WIDGET

$("#accordion").accordion({
  active: false,
  collapsible: true,
  beforeActivate: function(event, ui) {
    ui.newHeader.find(".fa-plus").removeClass("fa-plus").addClass("fa-minus");
    ui.oldHeader.find(".fa-minus").removeClass("fa-minus").addClass("fa-plus");
  },
  heightStyle: "content"
});
